import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import MobileChat from "./mobile/MobileChat";
import DesktopChat from "./desktop/DesktopChat";
import LoadingColumn from "./desktop/LoadingColumn";
import AuthColumn from "./desktop/AuthColumn";

class SidebarChat extends React.Component {

	render() {
		const loading = !this.props.user && !this.props.auth;

		if (loading) {
			return <div className={ `wcSidebar wcSize${ this.props.windowSizeClass } ${this.props.isMobile ? 'wcMobile' : 'wcDesktop' }` }>
				<LoadingColumn />
			</div>;
		}

		return(
			<div className={ `wcSidebar wcSize${ this.props.windowSizeClass } ${this.props.isMobile ? 'wcMobile' : 'wcDesktop' }` }>
				{ this.props.user && this.props.initiated &&
					<React.Fragment>
						{this.props.isMobile ? <MobileChat/> : <DesktopChat/>}
					</React.Fragment>
				}
				{ this.props.user === null && this.props.auth &&
					<AuthColumn />
				}
			</div>
		)
	}

}

SidebarChat.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		user: state.application.user,
		auth: state.application.auth,
		initiated: state.ui.initiated,
		windowSizeClass: state.ui.properties.windowSizeClass,
		isMobile: state.ui.properties.isMobile
	})
)(SidebarChat);